var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgActivateIcon = function SvgActivateIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "96px",
    viewBox: "0 0 97 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FC991",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B8E5E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounselling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.4.1.7.1-RM-/-Counsellors-----activate-counsellor",
    transform: "translate(-672, -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/03.Popup/No-subtext-Copy-2",
    transform: "translate(520, 259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(152.597, 40)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 48,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E2F2FF",
    opacity: 0.200000003,
    cx: 48,
    cy: 48,
    r: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(28, 28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9767578,9.06249992 C23.1445313,9.06249992 26.3574219,10.0571288 29.2674805,11.9383788 C31.8979493,13.6371093 34.2447267,16.0132812 36.0535157,18.8105469 C36.51983,19.5332462 36.5225,20.4613484 36.0603517,21.1867188 C34.2583985,24.0072266 31.9164063,26.3922852 29.2873048,28.0855469 C26.3895508,29.9510743 23.1698242,30.9375001 19.9767578,30.9375001 C16.711914,30.9375001 13.5742187,29.9804688 10.6586913,28.0916993 C8.0692382,26.416211 5.74570302,24.0366211 3.94033192,21.2113281 C3.46094416,20.4675421 3.47822564,19.5078798 3.98408192,18.7818359 C6.1749999,15.6407226 8.69746086,13.2009765 11.4817382,11.530957 C14.2120117,9.89306633 17.0701172,9.06249992 19.9767578,9.06249992 Z M20,13.4375 C16.3756313,13.4375 13.4375,16.3756313 13.4375,20 C13.4375,23.6243687 16.3756313,26.5625 20,26.5625 C23.6226509,26.5583562 26.5583562,23.6226509 26.5625,20 C26.5625,16.3756313 23.6243687,13.4375 20,13.4375 Z M20,15.625 C22.4162458,15.625 24.375,17.5837542 24.375,20 C24.375,22.4162458 22.4162458,24.375 20,24.375 C17.5837542,24.375 15.625,22.4162458 15.625,20 C15.625,17.5837542 17.5837542,15.625 20,15.625 Z",
    id: "Combined-Shape",
    fill: "#E0FFF4",
    mask: "url(#mask-3)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActivateIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activate-icon.ac7954c6.svg";
export { ForwardRef as ReactComponent };